import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { Box } from '@drone-js/core';
import { selectActivityContentLocale, selectActivityDescription, selectActivityItinerary, selectActivityLocations } from 'component/page/detail/store/detail.selectors';
import { ItineraryReference } from 'gql/autogen/ItineraryReference';
import { Location } from 'gql/autogen/Location';
import ItineraryRouteComponent from 'component/page/detail/Itineraries/HopOnHopOffItinerary/ItineraryRoute/ItineraryRoute';
import { TypographyWhitespacePreWrap } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStep';

interface StateProps {
    itinerary?: ItineraryReference;
    description?: string;
    location: Location[];
    contentLocale: string;
}

const HopOnHopOffItinerary: React.FC<StateProps> = ({ itinerary, description, location, contentLocale }) => {
    if (!itinerary) {
        return null;
    }

    const routes = itinerary.itineraryRoutes || [];
    if (!description && routes.length === 0) {
        return null;
    }

    return (
        <Box data-testid="detail-itinerary-hop" py="12" px="0">
            {description && (
                <TypographyWhitespacePreWrap mb="8" data-testid="itinerary-description" variant="body-s" tag="h3" role="heading" aria-level={3} lang={contentLocale}>
                    {description}
                </TypographyWhitespacePreWrap>
            )}
            {routes.map((itineraryRoute, index) => (
                <ItineraryRouteComponent key={index} itineraryRoute={itineraryRoute} locations={location} contentLocale={contentLocale} />
            ))}
        </Box>
    );
};
HopOnHopOffItinerary.displayName = 'HopOnHopOffItinerary';

const mapStateToProps = createSelector(
    selectActivityItinerary,
    selectActivityDescription,
    selectActivityLocations,
    selectActivityContentLocale,
    (itinerary, description, location, contentLocale) => {
        return { itinerary, description, location, contentLocale };
    },
);

export default connect(mapStateToProps)(HopOnHopOffItinerary);
